import * as React from 'react';

export const ErrorComponent = function () {
    return  <div>
                Mensaje de error
            </div>;
}